import { FILES_FETCH_SUCCESS, FILES_FETCH_FAIL } from '../constant/actionType';

export const initialState = {
  files: [],
  isFailed: false,
  isLoaded: false
};

const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILES_FETCH_SUCCESS: {
      const { files } = action.data;

      return { ...state, files, isFailed: false, isLoaded: true };
    }

    case FILES_FETCH_FAIL: {
      return { ...state, isFaled: true, isLoaded: true };
    }

    default:
      return state;
  }
};

export default fileReducer;
